/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/skills-common';

import ProgressBar from './ProgressBar';

const styles = {
  progressTrackerHeader: css`
    display: flex;
    justify-content: between;
    align-items: baseline;
    margin-top: -6px;
  `,
  score: css`
    flex: 0 0 auto;
    display: flex;
    margin-top: var(--cds-spacing-100);
  `,
};

const UnscorableProgressTracker = () => {
  return (
    <div>
      <div css={styles.progressTrackerHeader}>
        <Typography2 variant="bodySecondary" component="span" css={styles.score}>
          {_t('Skill scoring coming soon')}
        </Typography2>
      </div>
      <ProgressBar
        palette={{
          empty: 'var(--cds-color-grey-50)',
          border: 'var(--cds-color-grey-50)',
        }}
      />
    </div>
  );
};

export default UnscorableProgressTracker;
